/*
 *   File : empty.js
 *   Author : https://evoqins.com
 *   Description : Empty screen component
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React from 'react';

const EmptyScreen = (props) => {
    return (
        <div className={`${props.className} text-center ${props.padding ? props.padding : " py-5 my-5"}`}>
            <img src={props.image}
                draggable={false}
                width={props.width ? props.width : 200}
                height={props.height ? props.height : 200}
                className='mb-3'
                alt='empty data' />

            <h6 className='mb-1 e-text-dark-gray e-alt-font e-font-20 e-font-weight-600 line-height-28px '>
                {props.title}
            </h6>
            <div className='row'>
                <div className='offset-xl-4 offset-lg-3 offset-md-2 offset-1 col-xl-4 col-lg-6 col-md-8 col-10 px-0 '>
                    <p className={`${props.fontSize ? props.fontSize : "e-font-18 line-height-24px"} mb-0 e-text-arsenic e-alt-font  e-font-weight-400  `}>
                        {props.description}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default EmptyScreen;
